@if (!!learningPath) {
  <div class="hybrid py-3 py-xxl-5">
    <app-carousel #moduleCarousel [title]="learningPath.name">
      @for (module of learningPath.modules; track trackModule($index, module)) {
        <div class="module">
          <div class="module-title">
            <h2>{{module.name}}</h2>
          </div>
          <div class="trainings d-flex">
            @for (learningPathTraining of module.items; track learningPathTraining) {
              <div
                #trainingCards
                [attr.current]="isCurrentCard(learningPathTraining)"
                class="d-flex card">
                @if (learningPathTraining.type === 'training') {
                  @if (learningPathTraining.training; as training) {
                    <app-training-card [training]="training" [isLocked]="isLocked(learningPathTraining.starts_at)"> </app-training-card>
                  }
                } @else {
                  <app-livetraining-card
                    [liveTraining]="learningPathTraining"
                  [isLocked]="isLocked(learningPathTraining.starts_at, learningPathTraining.ends_at)"></app-livetraining-card>
                }
              </div>
            }
          </div>
        </div>
      }
    </app-carousel>
  </div>
}
